import { render, staticRenderFns } from "./col.vue?vue&type=template&id=04d1ec12&scoped=true&"
import script from "./col.vue?vue&type=script&lang=js&"
export * from "./col.vue?vue&type=script&lang=js&"
import style0 from "./col.vue?vue&type=style&index=0&id=04d1ec12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d1ec12",
  null
  
)

component.options.__file = "col.vue"
export default component.exports